<template>
  <div>
    <div class="space-between align-center">
      <div class="align-center flex-1">
        <div class="filter-icon">
          <img src="/img/filter.svg" alt="" />
        </div>
        <div class="search-wrappper">
          <b-input-group size="sm">
            <b-form-input
              v-model="filter"
              placeholder="Search here..."
            ></b-form-input>

            <b-input-group-append>
              <b-button :disabled="!filter" @click="filter = ''">
                Clear
              </b-button>
            </b-input-group-append>
          </b-input-group>
        </div>
      </div>

      <my-button
        type="orange"
        @click="addModal = true"
      >
        <fa-icon icon="edit" class="my-icon" />&nbsp; BUAT JURUSAN BARU
      </my-button>
    </div>
    <br />
    <br />

    <label>Filter Jenjang</label><br />
      <b-input-group size="sm">
        <b-form-select
          v-model="level_id"
          :options="levelOptionList"
          class="my-select"
        ></b-form-select>
      </b-input-group>
    <br /><br />

    <!-- Main table element -->
    <b-table
      show-empty
      stacked="md"
      :busy="isBusy"
      :items="items"
      :fields="fields"
      :current-page="currentPage"
      :per-page="perPage"
      :filter="filter"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      :sort-direction="sortDirection"
      @filtered="onFiltered"
    >
      <template v-slot:table-busy>
        <div class="text-center text-danger my-2">
          <b-spinner class="align-middle"></b-spinner>
          <strong>Loading...</strong>
        </div>
      </template>

      <template #cell(actions)="row">
        <b-button
          size="sm"
          class="mr-3 action-button"
          variant="outline-secondary"
          @click="handleEdit(row.item.id)"
        >
          <fa-icon icon="pencil-alt" class="my-icon" />&nbsp;Edit
        </b-button>
        <b-button
          size="sm"
          class="mr-3 action-button"
          variant="outline-danger"
          @click="handleDelete(row.item)"
        >
          <fa-icon icon="minus-circle" class="my-icon" />&nbsp;Delete
        </b-button>
      </template>
    </b-table>

    <b-row>
      <b-col md="6" class="my-1">
        <b-pagination
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
          class="my-0"
        ></b-pagination>
      </b-col>
    </b-row>
    <b-modal
      v-model="addModal"
      id="addModal"
      hide-header
      hide-footer
      centered
      size="lg"
    >
      <modal-cross @close="addModal = false"></modal-cross>
      <div class="p-4">
        <h3 class="txt-center color2">Buat Jurusan Baru</h3>
        <br />
        <label>Pilih Jenjang</label>
        <br />
        <b-form-select
          v-model="inputData.level_id"
          :options="levelOption"
          required
        ></b-form-select>
        <br />
        <br />
        <br />
        <label>Nama Jurusan</label>
        <br />
        <b-form-input
          placeholder="Nama .. "
          v-model="inputData.name"
        ></b-form-input>
        <br />
        <label>Deskripsi</label>
        <b-form-input
          placeholder="Deskripsi Singkat .. "
          v-model="inputData.description"
        ></b-form-input>
        <br />
        <div class="justify-end">
          <my-button
            type="blue"
            disabled
            v-show="showLoading"
          >
            <b-spinner small></b-spinner>
            <span class="sr-only">Loading...</span>
          </my-button>
          <my-button
            type="blue"
            v-show="!showLoading"
            @click="addMajor"
          >
            SIMPAN
          </my-button>
        </div>
        <br />
      </div>
    </b-modal>

    <b-modal
      v-model="editModal"
      id="editModal"
      hide-header
      hide-footer
      centered
      size="lg"
    >
      <modal-cross @close="editModal = false"></modal-cross>
      <div class="p-4">
        <h3 class="txt-center color2">Edit Jurusan</h3>
        <br />
        <label>Pilih Jenjang</label>
        <br />
        <b-form-select
          v-model="editData.level_id"
          :options="levelOption"
          disabled
        ></b-form-select>
        <br />
        <br />
        <br />
        <label>Nama Jurusan</label>
        <br />
        <b-form-input
          placeholder="Nama .. "
          v-model="editData.name"
        ></b-form-input>
        <br />
        <label>Deskripsi</label>
        <b-form-input
          placeholder="Deskripsi Singkat .. "
          v-model="editData.description"
        ></b-form-input>
        <br />
        <div class="justify-end">
          <my-button
            type="blue"
            disabled
            v-show="showLoading"
          >
            <b-spinner small></b-spinner>
            <span class="sr-only">Loading...</span>
          </my-button>
          <my-button
            type="blue"
            v-show="!showLoading"
            @click="editMajor"
          >
            SIMPAN
          </my-button>
        </div>
        <br />
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import * as types from "@/store/types";

export default {
  data() {
    return {
      level_id: null,
      levelOptionList: [],
      isBusy: false,
      items: [],
      fields: [
        {
          key: "no",
          label: "No"
        },
        {
          key: "name",
          label: "Nama",
          sortable: true,
          sortDirection: "desc"
        },
        {
          key: "level",
          label: "Jenjang",
          sortable: true,
          sortDirection: "desc"
        },
        {
          key: "description",
          label: "Deskripsi",
          sortable: true
        },
        {
          key: "actions",
          label: "Action"
        }
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 50,
      sortBy: null,
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      addModal: false,
      editModal: false,
      inputData: {
        name: "",
        description: "",
        level_id: null
      },
      editData: {
        name: "",
        description: "",
        id: 0,
        level_id: null
      },
      showLoading: false,
      levelOption: []
    };
  },

  computed: {
    ...mapGetters({
      isLoggedIn: "isLoggedIn"
    })
  },
  created() {
    if (!this.isLoggedIn) {
      this.$router.push("/login");
    }
  },

  mounted() {
    this.totalRows = this.items.length;
    this.levelList();
    if(this.$route.query.level) {
      this.majorList(this.$route.query.level);
      this.level_id = this.$route.query.level;
    } else {
      this.majorList();
    }
  },

  watch: {
    level_id: function(newVal) {
      if(newVal) {
        this.$router.push("/master-data/major?level="+newVal);
      } else {
        this.$router.push("/master-data/major");
      }
    },
    $route: function(newVal) {
      this.majorList(newVal.query.level);
    }
  },

  methods: {
    ...mapActions({
      getLevelList: types.GET_LEVEL_LIST,
      getMajorList: types.GET_MAJOR_LIST,
      setNewMajor: types.SET_NEW_MAJOR,
      getMajorDetail: types.GET_MAJOR_DETAIL,
      updateMajor: types.UPDATE_MAJOR,
      deleteMajor: types.DELETE_MAJOR
    }),
    levelList() {
      this.getLevelList()
        .then(response => {
          var res = response;
          this.levelOption = [];
          this.levelOptionList = [{value: null, text: "All"}];
          for (var i = 0; i < res.length; i++) {
            var dataLevel = {
              value: res[i].id,
              text: res[i].name
            };
            this.levelOption.push(dataLevel);
            this.levelOptionList.push(dataLevel);
          }
        })
        .catch(error => {
          this.showMessageBox(error, "Failed", "success");
        });
    },
    majorList(level_id = null) {
      level_id = this.$route.query.level ? this.$route.query.level : null;
      this.isBusy = true;
      this.getMajorList({params: {level: level_id}})
        .then(response => {
          var res = response;
          this.items = [];
          for (var i = 0; i < res.length; i++) {
            var dataItem = {
              no: i + 1,
              id: res[i].id,
              name: res[i].name,
              level: res[i].level,
              level_id: res[i].level_id,
              description: res[i].description
            };
            this.items.push(dataItem);
          }
          this.totalRows = res.length;
          this.isBusy = false;
        })
        .catch(error => {
          this.showMessageBox(error, "Failed", "success");
        });
    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    handleEdit(no) {
      this.editModal = true;
      this.getMajorDetail(no)
        .then(response => {
          var res = response;
          this.editData.name = res.name;
          this.editData.description = res.description;
          this.editData.id = res.id;
          this.editData.level_id = res.level_id;
        })
        .catch(error => {
          this.showMessageBox(error, "Failed", "success");
        });
    },
    handleDelete(index) {
      this.$bvModal.msgBoxConfirm('Delete this data?', {
        title: 'Confirm',
        size: 'sm',
        buttonSize: 'sm',
        okVariant: 'danger',
        okTitle: 'YES',
        cancelTitle: 'NO',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true
      })
        .then(value => {
          if(value) {
            this.deleteMajor({id:index.id})
              .then(response => {
                this.majorList();
                this.showMessageBox("Deleted", "Success", "success");
              })
              .catch(error => {
                this.showMessageBox(error, "Failed", "success");
              });
          }
        })
        .catch(err => {
          this.showMessageBox(err, "Failed", "success");
        });
    },
    closeModal() {
      this.$bvModal.hide("modal-confirm");
    },
    addMajor() {
      this.showLoading = true;
      this.setNewMajor(this.inputData)
        .then(response => {
          // eslint-disable-next-line
          var res = response;
          this.addModal = false;
          this.showLoading = false;
          this.inputData = {
            name: "",
            description: "",
            level_id: null
          };
          this.majorList();
        })
        .catch(error => {
          this.showLoading = false;
          this.showMessageBox(error, "Failed", "success");
        });
    },
    editMajor() {
      this.showLoading = true;
      this.updateMajor(this.editData)
        .then(response => {
          // eslint-disable-next-line
          var res = response;
          this.editModal = false;
          this.showLoading = false;
          this.majorList();
        })
        .catch(error => {
          this.showLoading = false;
          this.showMessageBox(error, "Failed", "success");
        });
    },
    showMessageBox(message, title, variant) {
      this.$bvModal
        .msgBoxOk(message, {
          title: title,
          size: "sm",
          buttonSize: "sm",
          okVariant: variant,
          centered: true
        })
        .then(value => {
          this.temp = value;
        })
        .catch(err => {
          this.temp = err;
        });
    }
  }
};
</script>

<style>
.search-wrapper {
  width: 100%;
  max-width: 222px;
}

.filter-icon {
  margin-right: 11px;
  background-color: #e9e9e9;
  width: 32px;
  height: 32px;
  border-radius: 32px;
  text-align: center;
  padding-top: 7px;
}

.action-button:hover {
  background-color: #f08045;
  border: 1px solid #f08045;
}
</style>